module.exports = __webpack_public_path__ + "static/media/help.9bd1c6c4.svg";